import Handler from "../Handler";

class TourneyRebuyFailAckHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processTourneyRebuyFailureAck(receivedData);
  }
}
export default TourneyRebuyFailAckHandler;
